import {getHours, isValid} from 'date-fns';
import {match} from 'ts-pattern';

/**
 * Calculates the position for rental events with quarter-hour rounding based on hours
 * @param date The date to calculate position for
 * @returns Rounded hours and minutes for positioning to quarter boundaries
 * @throws Error
 */
export function calculateRentalTimePosition(date: Date) {
  if (!isValid(date)) {
    throw new Error('Invalid date provided');
  }

  return match(getHours(date))
    .when(
      (hours) => hours >= 0 && hours < 6,
      () => ({hours: 0, minutes: 0}) // Quarter 1: Start of day
    )
    .when(
      (hours) => hours >= 6 && hours < 12,
      () => ({hours: 6, minutes: 0}) // Quarter 2: 6 AM
    )
    .when(
      (hours) => hours >= 12 && hours < 18,
      () => ({hours: 12, minutes: 0}) // Quarter 3: 12 PM
    )
    .when(
      (hours) => hours >= 18 && hours < 24,
      () => ({hours: 18, minutes: 0}) // Quarter 4: 6 PM
    )
    .otherwise(() => ({hours: 0, minutes: 0})); // Fallback
}
